import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/pages/Login.vue';
import Library from '@/pages/Library.vue';
import Book from '@/pages/Book.vue';
import BookDetail from '@/pages/BookDetail.vue';
import Classes from '@/pages/Classes.vue';


Vue.use(Router);

const router = new Router({
  routes: [
    { path: '/' || '/login', component: Login },
    { path: '/library', component: Library },
    { path: '/book', component: Book },
    { path: '/book/:id', component: BookDetail },
    { path: '/classes', component: Classes }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/', '/login'];
  const authRequired = !publicPages.includes(to.path);
  const token = localStorage.getItem('token');

  if (authRequired && !token) {
    return next('/');
  }

  next();
});

export default router;